import React, { useState, useEffect, useRef } from 'react';
import { Menu, Search, User, ShoppingCart, X, TagIcon, Minus, Plus, Trash2, Tag, Users, ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { cartToOrder, groupcartToOrder } from './events/action';
import axios from 'axios';
import { isTokenExpired } from '../MiddleWare/verifyToken';
import { Oval } from 'react-loader-spinner';
import { io } from 'socket.io-client';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Groups = () => {
  const navigate = useNavigate();
  const [CategoryData, setCategoryData] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [itemToggleStates, setItemToggleStates] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [productQuantities, setProductQuantities] = useState({});
  const exclusiveRangeRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [cartData, setCartData] = useState(null);
  const [error, setError] = useState('');
  const [groups, setGroups] = useState([]);
  const [groupCarts, setGroupCarts] = useState([]);
  const [currentUserCart, setCurrentUserCart] = useState(null);
  const [otherMemberCarts, setOtherMemberCarts] = useState([]);
  const [totalGroupAmount, setTotalGroupAmount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [cartUpdateTrigger, setCartUpdateTrigger] = useState(false);
  const [isCartToggle, setIsCartToggle] = useState(false);
  const [existingGroupCode, setExistingGroupCode] = useState('');
  const [isGroupAdmin, setIsGroupAdmin] = useState(false);
  const [isPolling, setIsPolling] = useState(true);
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [addressUpdateTrigger, setAddressUpdateTrigger] = useState(0);
  const [customerData, setCustomerData] = useState(null);
  const [isCatLoading, setIsCatLoading] = useState(true);
  const [socket, setSocket] = useState(null);
  const [stockLevels, setStockLevels] = useState({});
  const [stockLevelsforproduct, setStockLevelsforproduct] = useState({});


  const [address, setAddress] = useState({
    line1: '',
    line2: '',
    pincode: ''
  });



  useEffect(() => {
    const checkUserGroup = async () => {
      try {
        const userId = await getCurrentUserId();
        const response = await axios.get(`${process.env.REACT_APP_URL}/api/fetchgroups`);
        setGroups(response.data || []);
        console.log("res", response.data)
        // Find user's group
        const userGroup = response.data?.find(group =>
          group.groupmembers.some(member =>
            member.customer_generated_id === userId
          )
        );

        if (userGroup) {
          setExistingGroupCode(userGroup.groupcode);
          console.log("user", userGroup.groupcode)
          setError(`You are already a member of a group with code: ${userGroup.groupcode}`);
        }

        const groupAddressData = userGroup.groupaddress;
        console.log("address", groupAddressData)
        if (groupAddressData && groupAddressData.length > 0) {
          localStorage.setItem('address', JSON.stringify(groupAddressData));  // Using 'address' as the key
          setAddressUpdateTrigger(prev => prev + 1);
        }
      } catch (error) {
        console.error('Error checking user group:', error);
        setError('Failed to check group membership. Please try again later.');
      }
    };

    checkUserGroup();
  }, []);

  useEffect(() => {
    const savedAddress = JSON.parse(localStorage.getItem('address'));

    if (savedAddress && Array.isArray(savedAddress) && savedAddress.length > 0) {
      const addressObject = savedAddress[0];
      console.log("Loading address:", addressObject);
      setAddress(addressObject);
    } else {
      console.log("No saved address found or invalid data.");
      setAddress({
        line1: '',
        line2: '',
        pincode: ''
      });
    }
  }, [addressUpdateTrigger]);


  useEffect(() => {
    fetchToggleState();
    fetchStockLevelsforproducts();
  }, []);

  const fetchStockLevelsforproducts = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_URL}/api/stock-levels`);
      const stockData = response.data.reduce((acc, item) => {
        acc[item.productid] = item.quantity;
        return acc;
      }, {});
      setStockLevelsforproduct(stockData);
      console.log("stockData", stockData)
    } catch (error) {
      console.error('Error fetching stock levels:', error);
    }
  };
  const fetchToggleState = async () => {
    const groupCode = localStorage.getItem('groupCode');
    if (!groupCode) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/toggle-state/${groupCode}`,
        {
          headers: { token: localStorage.getItem('token') }
        }
      );
      setIsCartToggle(response.data.isToggled);
    } catch (error) {
      console.error('Error fetching toggle state:', error);
    }
  };

  const fetchCustomerDetails = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_URL}/api/mycustomers`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("customer data", data)
      setCustomerData(data);
    } catch (error) {
      console.error('Failed to fetch customer data:', error);
    }
  };

  useEffect(() => {
    fetchCustomerDetails();
  }, []);

  const handleCartToggle = async () => {
    const groupCode = localStorage.getItem('groupCode');
    if (!groupCode) return;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/toggle-state/${groupCode}`,
        {
          isToggled: !isCartToggle
        },
        {
          headers: { token: localStorage.getItem('token') }
        }
      );

      if (response.data.success) {
        setIsCartToggle(!isCartToggle);
      }
    } catch (error) {
      console.error('Error updating toggle state:', error);
      if (error.response?.status === 403) {
        alert('Only group admin can change toggle state');
      }
    }
  };



  const getCurrentUserId = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('Unauthorized');
    }
    const response = await fetch(`${process.env.REACT_APP_URL}/api/user/getuser/${token}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.customer_generated_id;
  };


  useEffect(() => {
    const savedAddress = JSON.parse(localStorage.getItem('address'));
    if (savedAddress && Array.isArray(savedAddress) && savedAddress.length > 0) {
      setAddress(savedAddress[0]);
    }
  }, []);
  const handleChangeAddress = () => {
    navigate('/groupAddress');
  };
  const checkAdminStatus = async () => {
    try {
      const userId = await getCurrentUserId();
      const groupCode = localStorage.getItem('groupCode');
      const response = await axios.get(`${process.env.REACT_APP_URL}/api/fetchgroups`);
      const groups = response.data;

      // Find the user's group
      const userGroup = groups.find(group => group.groupcode === groupCode);

      if (userGroup) {
        // Check if current user is the group creator/admin
        const isAdmin = userGroup.groupmembers.some(member =>
          member.customer_generated_id === userId && member.role === 'admin'
        );
        setIsGroupAdmin(isAdmin);
      }
    } catch (error) {
      console.error('Error checking admin status:', error);
    }
  };

  // Add this to useEffect to check admin status when component mounts
  useEffect(() => {
    checkAdminStatus();
  }, []);

  const PackRadioSelector = ({ item, availablePacks = [], onToggle }) => {
    const selectedPack = itemToggleStates[item.productid];
    return (
      <div className="flex items-center gap-3">
        <span className="text-sm font-large font-bold text-orange-500">Pack </span>
        <div className="flex gap-4">
          {availablePacks.map((pack) => (
            <label
              key={pack}
              className="flex items-center gap-1.5 cursor-pointer group"
            >
              <input
                type="radio"
                name={`packSize-${item.productid}`}
                checked={selectedPack === pack}
                onChange={() => onToggle(item.productid, pack)}
                className="w-4 h-4 text-orange-600 border-gray-300 focus:ring-orange-500 cursor-pointer accent-orange-600"
              />
              <span className="text-sm font-medium text-gray-600 group-hover:text-orange-600">
                {pack.replace('PackOf', '')}
              </span>
            </label>
          ))}
        </div>
      </div>
    );
  };
  const carouselImages = [
    {
      id: 1,
      image: "https://d1csarkz8obe9u.cloudfront.net/posterpreviews/dwl-72-design-template-3c2e6e49a11feb109e2b0d06f14f2b99_screen.jpg?ts=1698161553"
    },
    {
      id: 2,
      image: "https://d1csarkz8obe9u.cloudfront.net/posterpreviews/dwl-65-design-template-28c17e539a730c4a5bc939e92c41936b_screen.jpg?ts=1698091392"
    },
    {
      id: 3,
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSs8PWlMREDcXgnZuRIZ1gKqO7cznfU9EqmTw&s"
    }
  ];
  const categoryImages = {
    'Bombs': 'https://www.shutterstock.com/image-photo/diwali-fire-bomb-cracker-on-600nw-1483388597.jpg',
    'Sparklers': 'https://www.crackersindia.com/wp-content/uploads/2019/01/10_cm_red_sparklers-500x500.jpg',
    'Flower Pots': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTxcvgRvrm90y6okYWnOCyFMkDs-0cxllg7hA&s',
    'Chakkar': 'https://www.shutterstock.com/image-photo/top-view-type-fireworkcracker-known-600w-163927880.jpg',
    'Novel': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT607zPn2ofbaglyOud8OkQYPoWRWjXtiPLKw&s',
    'Bijili': 'https://bijili.s3.ap-south-1.amazonaws.com/product/bij_034a.jpg',
    'Rockets': 'https://www.sivakasifireworks.net/wp-content/uploads/2017/01/rockets.png',
    'Gift Boxes': 'https://www.crackersindia.com/wp-content/uploads/2019/01/images8-500x500_1.jpg',
    'Wala': 'https://www.crackersindia.com/wp-content/uploads/2019/01/images8-500x500_1.jpg',
    'Shots': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_wv8gaBY6jMWoqKLDiAi5NohbRfdeOANU8Q&s',
    'Roll Caps': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ5ImSoarkIZf8y9hD4aodxHKBLIHJ52iy_yg&s'
  };



  useEffect(() => {
    fetchProducts();
    fetchCartItems();
    fetchGroupCarts();
  }, []);

  useEffect(() => {
    const savedCoupon = localStorage.getItem('appliedCoupon');
    if (savedCoupon) {
      const couponData = JSON.parse(savedCoupon);
      setAppliedCoupon(couponData);
      setIsCouponApplied(true);
    }
  }, []);

  // Watch for cart total changes and validate coupon
  useEffect(() => {
    if (appliedCoupon) {
      const cartTotal = calculateOriginalTotal();
      if (cartTotal < appliedCoupon.min_cart_amt) {
        // removeCoupon();
        setError(`Minimum cart amount should be ₹${appliedCoupon.min_cart_amt} for this coupon`);
      }
    }
  }, [currentUserCart]);

  useEffect(() => {
    const fetchGroupCarts = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          throw new Error('Unauthorized');
        }
        const groupCode = localStorage.getItem('groupCode');
        console.log("groupCode", groupCode)
        const response = await fetch(`${process.env.REACT_APP_URL}/api/groupcart/getcart/${groupCode}`, {
          headers: { token },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("data", data.data.groupCarts[0].memberId)

        if (data.success) {

          const userId = await getCurrentUserId();
          console.log("har", userId) // You'll need to implement this
          // data.data.groupCarts.forEach(cart => console.log("cart.memberId", cart.memberId));

          const currentUserCart = data.data.groupCarts.find(cart => cart.memberId === userId);
          console.log()
          const otherCarts = data.data.groupCarts.filter(cart => cart.memberId !== userId);

          setCurrentUserCart(currentUserCart);
          console.log("currentUserCart", currentUserCart)
          setOtherMemberCarts(otherCarts);
          console.log("otherCarts", otherCarts)
          setTotalGroupAmount(data.data.groupTotal);
          console.log("data.data.groupTotal", data.data.groupTotal)
        }
      } catch (error) {
        console.error('Error fetching group carts:', error);
        setError('Failed to load group carts');
      } finally {
        setIsLoading(false);
      }
    };
    fetchGroupCarts();
  }, [cartUpdateTrigger])


  useEffect(() => {
    const socketUrl = `${process.env.REACT_APP_URL}`;
    console.log('Socket connecting...', socketUrl);
    const newSocket = io(socketUrl, {
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      timeout: 10000,
    });
    newSocket.on('connect', () => {
      console.log(`Connected to server with socket id: ${newSocket.id}`);
      newSocket.emit('message', 'Hello from React Native!');
    });

    newSocket.on('connect_error', (error) => {
      console.error('Socket connection error details:', {
        message: error.message,
        description: error.description,
        context: error.context,
        type: error.type
      });
    });

    newSocket.on('groupCartUpdated', (data) => {
      console.log('groupCart updated:', data);
      fetchGroupCarts();
    });

    newSocket.on('groupToggleChanged', (data) => {
      console.log('group Toggle changed:', data);
      fetchToggleState();
    });
    newSocket.on('message', (data) => {
      console.log(`Message from server: ${data}`);
    });

    newSocket.on('disconnect', () => {
      console.log('Disconnected from server');
    });

    setSocket(newSocket);

    // Cleanup on unmount
    return () => {
      if (newSocket) {
        newSocket.disconnect();
      }
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userDP');
    localStorage.removeItem('address');

    setTimeout(() => {
      window.location.href = '/';
    }, 0);
  };

  const calculateOriginalTotal = () => {
    if (!currentUserCart || !currentUserCart.cartData) return 0;
    return currentUserCart.cartData.reduce((total, item) => {
      const selectedPack = item.selectedPack;
      const itemPrice = item[selectedPack];
      return total + (itemPrice * item.quantity);
    }, 0);
  };

  const calculateDiscountedTotal = () => {
    const originalTotal = calculateOriginalTotal();
    if (appliedCoupon && originalTotal >= appliedCoupon.min_cart_amt) {
      const discountAmount = (originalTotal * appliedCoupon.discount) / 100;
      return originalTotal - discountAmount;
    }
    return originalTotal;
  };


  const calculateGrandTotal = () => {
    let total = 0;

    // Add total from other member carts
    if (otherMemberCarts && otherMemberCarts.length > 0) {
      total += otherMemberCarts.reduce((sum, cart) => sum + cart.totalAmount, 0);
    }

    // Add current user's cart total
    if (currentUserCart) {
      total += currentUserCart.totalAmount;
    }

    return total;
  }
  const calculateDiscountedGrandTotal = () => {
    const originalTotal = calculateGrandTotal();
    if (appliedCoupon && originalTotal >= appliedCoupon.min_cart_amt) {
      const discountAmount = (originalTotal * appliedCoupon.discount) / 100;
      return originalTotal - discountAmount;
    }
    return originalTotal;
  };


  const checkStockAvailability = async (items) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/check-stock`,
        { items }
      );
      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      return response.data;
    } catch (error) {
      console.error('Stock check error:', error);
      throw error;
    }
  };
  const fetchStockLevels = async (allCartsData, setStockLevels) => {
    try {
      const items = allCartsData.flatMap(cart =>
        cart.cartData.map(item => ({
          productid: item.productid,
          quantity: item.quantity,
          // selectedPack: item.selectedPack
        }))
      );

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/check-stock`,
        { items }
      );

      // Transform the response into a map of productid -> stock status
      const stockMap = {};
      response.data.unavailableItems?.forEach(item => {
        stockMap[item.productid] = true; // true indicates out of stock
      });
      setStockLevels(stockMap);
    } catch (error) {
      console.error('Error fetching stock levels:', error);
    }
  };





  const handleSubmit = async () => {
    const groupCode = localStorage.getItem('groupCode');
    const allCartsData = [...(otherMemberCarts || []), currentUserCart].filter(Boolean);
    const allItems = allCartsData.flatMap(cart => cart.cartData);
    console.log("chnadrika", allItems);

    try {
      // Aggregate quantities for duplicate products
      const aggregatedItems = allItems.reduce((acc, item) => {
        const existingItem = acc.find(i => i.productid === item.productid);
        if (existingItem) {
          existingItem.quantity += item.quantity;
        } else {
          acc.push({ ...item });
        }
        return acc;
      }, []);

      // Check stock availability with aggregated quantities
      const stockResponse = await checkStockAvailability(aggregatedItems);



      if (!stockResponse.isAvailable) {

        // Format unavailable items with HTML line breaks
        const unavailableItems = stockResponse.unavailableItems.map(item =>
          `${item.name} (Requested: ${item.requestedQuantity}, Available: ${item.actualAvailableQuantity})`
        ).join("<br/>");

        // Show toast with formatted message
        toast.error(<div dangerouslySetInnerHTML={{ __html: `Some items are out of stock:<br/>${unavailableItems}` }} />, {
          position: "top-right",
          autoClose: 5000,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        return;
      }



      const totalOriginalAmount = calculateGrandTotal();
      const totalDiscountedAmount = calculateDiscountedGrandTotal();
      const orderDetails = allCartsData.map(cart => ({
        customer_generated_id: cart.memberId,
        cartData: cart.cartData,
        totalAmount: cart.totalAmount
      }));

      const updatedCartData = {
        total_amount: totalOriginalAmount,
        finalinvoicevalue: totalDiscountedAmount,
        groupCode: groupCode,
        orderDetails: orderDetails,
        address: address,
        couponcode: appliedCoupon ? appliedCoupon.couponcode : null,
        discount: appliedCoupon ? appliedCoupon.discount : null,
      };

      setLoading(true);
      const token = localStorage.getItem('token');

      if (!token || isTokenExpired(token)) {
        navigate("/");
        return;
      }

      console.log("Sending order data:", updatedCartData);
      const orderResponse = await groupcartToOrder(updatedCartData);

      const paymentResponse = await axios.post(
        `${process.env.REACT_APP_URL}/api/pay`,
        {
          amount: updatedCartData.finalinvoicevalue,
          original_amount: updatedCartData.total_amount,
          corporateorder_id: orderResponse.order_generated_id,
          groupCode: updatedCartData.groupCode,
          couponcode: updatedCartData.couponcode,
          discount: updatedCartData.discount,
        },
        {
          headers: { token: token }
        }
      );

      if (paymentResponse.data && paymentResponse.data.redirectUrl) {
        setAppliedCoupon(null);
        setIsCouponApplied(false);
        localStorage.removeItem('appliedCoupon');
        window.location.href = paymentResponse.data.redirectUrl;
      } else {
        throw new Error('Invalid payment response');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred during checkout');
      console.error('Checkout error:', err);
    } finally {
      setLoading(false);
    }
  };



  const fetchProducts = async () => {
    try {
      setIsCatLoading(true);

      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Unauthorized');
      }

      const response = await fetch(`${process.env.REACT_APP_URL}/api/products`, {
        headers: { token },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      const transformedData = data.reduce((acc, item) => {
        const category = item.category || 'Uncategorized';
        if (!acc[category]) {
          acc[category] = {
            category,
            image: categoryImages[category] || "/api/placeholder/80/80",
            items: []
          };
        }
        acc[category].items.push({
          ItemName: item.itemname,
          Brand: item.brand,
          SellingUnit: item.sellingunit,
          MCSellingPrice: item.mcsellingprice,
          PackOf1: item.packof1,
          PackOf2: item.packof2,
          PackOf5: item.packof5,
          PackOf10: item.packof10,
          productid: item.productid,
        });
        return acc;
      }, {});

      setCategoryData(Object.values(transformedData));
      setSelectedCategory(Object.keys(transformedData)[0]);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsCatLoading(false);
    }
  };

  const fetchCartItems = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Unauthorized');
      }

      const response = await fetch(`${process.env.REACT_APP_URL}/api/cart/getcart`, {
        headers: { token },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.cartitem && data.cartitem.cartData) {
        console.log("data3", data.cartitem.cartData)
        setCartItems(data.cartitem.cartData);
      } else {
        setCartItems([]);
      }
    } catch (error) {
      console.error('Error fetching cart items:', error);
      setCartItems([]);
    }
  };


  const handleAddToCart = async (item, selectedPack) => {
    console.log("Adding to cart...");
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/login');
        return;
      }

      const quantity = productQuantities[item.productid] || 1;
      const packSize = parseInt(selectedPack.replace(/PackOf/, '')) || 1;
      const newItemActualQuantity = packSize * quantity;

      // Calculate total quantity across all pack sizes in current cart
      const existingCartQuantity = currentUserCart?.cartData?.reduce((total, cartItem) => {
        if (cartItem.productid === item.productid) {
          const itemPackSize = parseInt(cartItem.selectedPack.replace(/PackOf/, '')) || 1;
          return total + (cartItem.quantity * itemPackSize);
        }
        return total;
      }, 0) || 0;

      // Calculate final quantity including the new item
      const finalQuantity = existingCartQuantity + newItemActualQuantity;
      console.log("Total quantity across all packs:", finalQuantity);

      // Stock availability check
      const stockCheckItems = [{
        productid: item.productid,
        quantity: finalQuantity,
        selectedPack: selectedPack
      }];

      const stockResponse = await checkStockAvailability(stockCheckItems);

      if (stockResponse.unavailableItems?.some(unavailableItem =>
        unavailableItem.productid === item.productid
      )) {
        toast.warn('Low Quantity Alert: Insufficient stock for selected items.');
        setProductQuantities(prev => ({
          ...prev,
          [item.productid]: 1
        }));
        return;
      }

      let cartArray = [];
      if (currentUserCart?.cartData) {
        cartArray = Array.isArray(currentUserCart.cartData)
          ? currentUserCart.cartData
          : JSON.parse(currentUserCart.cartData);
      }

      const existingItem = cartArray.find(
        cartItem => cartItem.productid === item.productid &&
          cartItem.selectedPack === selectedPack
      );

      let updatedCartData;
      if (existingItem) {
        updatedCartData = cartArray
          .filter(cartItem => !(
            cartItem.productid === item.productid &&
            cartItem.selectedPack === selectedPack
          ))
          .concat([{
            ...item,
            selectedPack,
            quantity: existingItem.quantity + quantity
          }]);
      } else {
        updatedCartData = [...cartArray, { ...item, selectedPack, quantity }];
      }

      const newTotalAmount = updatedCartData.reduce((sum, cartItem) => {
        return sum + (cartItem[cartItem.selectedPack] * cartItem.quantity);
      }, 0);

      const cartData = {
        totalAmount: newTotalAmount,
        cartData: updatedCartData,
        address: address
      };

      const response = await fetch(`${process.env.REACT_APP_URL}/api/groupcart/add`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          token
        },
        body: JSON.stringify(cartData)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      setProductQuantities(prev => ({ ...prev, [item.productid]: 1 }));
      setCartUpdateTrigger(prev => prev + 1);
      setError("");

      const allCarts = [
        { ...currentUserCart, cartData: updatedCartData },
        ...otherMemberCarts
      ];
      fetchStockLevels(allCarts, setStockLevels);

      fetchGroupCarts();

    } catch (error) {
      console.error('Error adding item to cart:', error);
      setError('Failed to add item to cart');
    }
  };







  const handleQuantityChange = (productId, change) => {
    setProductQuantities(prev => {
      const currentQty = prev[productId] || 1;
      const newQty = Math.max(1, currentQty + change); // Ensure quantity doesn't go below 1
      return {
        ...prev,
        [productId]: newQty
      };
    });
  };


  const updateQuantity = async (productId, selectedPack, newQuantity) => {
    if (newQuantity < 1) return;

    try {
      console.log('Before update:', cartItems);
      const updatedCart = cartItems.map(item => {
        if (item.productid === productId && item.selectedPack === selectedPack) {
          return { ...item, quantity: newQuantity };
        }
        return item;
      });
      console.log("updatedCart", updatedCart)
      const totalAmount = updatedCart.reduce((sum, cartItem) => {
        const selectedPack = cartItem.selectedPack;
        const itemPrice = cartItem[selectedPack];
        return sum + (itemPrice * cartItem.quantity);
      }, 0);

      const cartData = {
        totalAmount,
        cartData: updatedCart,
        address: address
      };
      const token = localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_URL}/api/groupcart/add`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          token
        },
        body: JSON.stringify(cartData)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      setCartItems(updatedCart);
    } catch (error) {
      console.error('Error updating quantity:', error);
    }
  };
  const calculateTotal = () => {
    return cartItems.reduce((total, item) => {
      const selectedPack = item.selectedPack;
      const itemPrice = item[selectedPack];
      return total + (itemPrice * item.quantity);
    }, 0);
  };
  const removeFromCart = async (productId, selectedPack) => {
    try {
      if (!currentUserCart?.cartData) return;

      // Filter out the item to be removed
      const updatedCartData = currentUserCart.cartData.filter(item =>
        !(item.productid === productId && item.selectedPack === selectedPack)
      );

      // Calculate new total amount
      const totalAmount = updatedCartData.reduce((sum, item) => {
        return sum + (item[item.selectedPack] * item.quantity);
      }, 0);

      // Prepare cart data for update
      const cartData = {
        totalAmount,
        cartData: updatedCartData,
        address
      };

      const token = localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_URL}/api/groupcart/add`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          token
        },
        body: JSON.stringify(cartData)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Trigger cart refresh
      setCartUpdateTrigger(prev => !prev);

    } catch (error) {
      console.error('Error removing item from cart:', error);
      // You might want to show an error message to the user here
    }
  };


  // const calculateTotal = () => {
  //   return cartItems.reduce((total, item) => {
  //     const selectedPack = item.selectedPack;
  //     const itemPrice = item[selectedPack];
  //     return total + (itemPrice * item.quantity);
  //   }, 0);
  // };

  const handleSelectCategory = (category) => {
    setSelectedCategory(category);
    setSearchTerm("");
    setIsMobileMenuOpen(false);
    if (exclusiveRangeRef.current) {
      exclusiveRangeRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleToggleChange = (itemId, pack) => {
    setItemToggleStates(prevStates => ({
      ...prevStates,
      [itemId]: pack
    }));
  };
  const fetchGroupCarts = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Unauthorized');
      }
      const groupCode = localStorage.getItem('groupCode');
      console.log("groupCode", groupCode)
      const response = await fetch(`${process.env.REACT_APP_URL}/api/groupcart/getcart/${groupCode}`, {
        headers: { token },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("data", data)

      if (data.success) {

        const userId = await getCurrentUserId();
        console.log("har", userId) // You'll need to implement this
        // data.data.groupCarts.forEach(cart => console.log("cart.memberId", cart.memberId));

        const currentUserCart = data.data.groupCarts.find(cart => cart.memberId === userId);
        console.log()
        const otherCarts = data.data.groupCarts.filter(cart => cart.memberId !== userId);

        setCurrentUserCart(currentUserCart);
        console.log("currentUserCart", currentUserCart)
        setOtherMemberCarts(otherCarts);
        console.log("otherCarts", otherCarts)
        setTotalGroupAmount(data.data.groupTotal);
        console.log("data.data.groupTotal", data.data.groupTotal)
      }
    } catch (error) {
      console.error('Error fetching group carts:', error);
      setError('Failed to load group carts');
    } finally {
      setIsLoading(false);
    }
  };

  const CartModal = () => {
    const [showCouponList, setShowCouponList] = useState(false);
    const [coupons, setCoupons] = useState([]);
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [expandedCarts, setExpandedCarts] = useState({});
    const [cartUpdateTrigger, setCartUpdateTrigger] = useState(0);
    const [stockLevels, setStockLevels] = useState({});


    useEffect(() => {
      if (currentUserCart && otherMemberCarts) {
        const allCarts = [currentUserCart, ...otherMemberCarts];
        fetchStockLevels(allCarts, setStockLevels);
      }
    }, [currentUserCart, otherMemberCarts]);
    useEffect(() => {
      if (showCouponList && coupons.length === 0) {
        fetchCoupons();
      }
    }, [showCouponList]);



    const updateCartQuantity = async (productId, selectedPack, newQuantity) => {
      if (newQuantity < 1) return;

      try {
        // Calculate total quantities across all cart items
        const totalQuantities = {};
        const updatedCartItems = currentUserCart.cartData.map(item => {
          if (item.productid === productId && item.selectedPack === selectedPack) {
            return { ...item, quantity: newQuantity };
          }
          return item;
        });

        updatedCartItems.forEach(item => {
          const itemPackSize = parseInt(item.selectedPack.replace(/PackOf/, '')) || 1;
          totalQuantities[item.productid] = (totalQuantities[item.productid] || 0) + (item.quantity * itemPackSize);
        });

        const stockCheckItems = Object.keys(totalQuantities).map(productid => ({
          productid,
          quantity: totalQuantities[productid]
        }));

        const stockResponse = await checkStockAvailability(stockCheckItems);

        if (stockResponse.unavailableItems?.some(item => item.productid === productId)) {
          toast.warn('Low Quantity Alert: Insufficient stock for selected items.');
          return;
        }

        // Calculate new total amount
        const newTotalAmount = updatedCartItems.reduce((sum, item) => {
          return sum + (item[item.selectedPack] * item.quantity);
        }, 0);

        // Prepare cart data for backend
        const cartData = {
          totalAmount: newTotalAmount,
          cartData: updatedCartItems,
          address: address
        };

        // Send update to backend
        const token = localStorage.getItem('token');
        const response = await fetch(`${process.env.REACT_APP_URL}/api/groupcart/add`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            token
          },
          body: JSON.stringify(cartData)
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Update local state and trigger refreshes
        setCartUpdateTrigger(prev => prev + 1);
        setError("");

        // Refresh stock levels
        const allCarts = [
          { ...currentUserCart, cartData: updatedCartItems },
          ...otherMemberCarts
        ];
        fetchStockLevels(allCarts, setStockLevels);

        // Fetch updated group carts
        fetchGroupCarts();
      } catch (error) {
        console.error('Error updating quantity:', error);
        setError('Failed to update quantity');
      }
    };


    const handleCouponButtonClick = () => {
      // if (isCouponApplied) {
      //     removeCoupon();
      // }
      setShowCouponList(prev => !prev);
      if (!showCouponList && coupons.length === 0) {
        setIsLoading(true);
        fetchCoupons();
      }
      // Clear any existing error message when opening coupon list
      setError("");
    };
    const calculateDiscountedGrandTotal = () => {
      const originalTotal = calculateGrandTotal();
      if (appliedCoupon && originalTotal >= appliedCoupon.min_cart_amt) {
        const discountAmount = (originalTotal * appliedCoupon.discount) / 100;
        return originalTotal - discountAmount;
      }
      return originalTotal;
    };
    const fetchCoupons = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_URL}/api/coupons`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setCoupons(data.filter((coupon) => coupon.status === 'active'));
        setError("");
      } catch (error) {
        console.error('Error fetching coupons:', error);
        setError('Failed to load coupons');
      } finally {
        setIsLoading(false);
      }
    };

    const calculateOriginalTotal = () => {
      if (!currentUserCart || !currentUserCart.cartData) return 0;
      return currentUserCart.cartData.reduce((total, item) => {
        const selectedPack = item.selectedPack;
        const itemPrice = item[selectedPack];
        return total + (itemPrice * item.quantity);
      }, 0);
    };

    const calculateDiscountedTotal = () => {
      const originalTotal = calculateOriginalTotal();
      if (appliedCoupon) {
        const discountAmount = (originalTotal * appliedCoupon.discount) / 100;
        return originalTotal - discountAmount;
      }
      return originalTotal;
    };

    const handleApplyCoupon = (coupon) => {
      const totalAmount = calculateGrandTotal();

      if (totalAmount < coupon.min_cart_amt) {
        setError(`Minimum cart amount should be ₹${coupon.min_cart_amt}`);
        return;
      }

      const discountAmount = (totalAmount * coupon.discount) / 100;
      const updatedCoupon = { ...coupon, discountAmount };

      setAppliedCoupon(updatedCoupon);
      setIsCouponApplied(true);
      setShowCouponList(false);
      setError("");

      localStorage.setItem('appliedCoupon', JSON.stringify(updatedCoupon));
    };



     const toggleCart = (memberId) => {
      setExpandedCarts(prev => ({
        ...prev,
        [memberId]: !prev[memberId]
      }));
    };
    
    const removeCoupon = () => {
      setAppliedCoupon(null);
      setIsCouponApplied(false);
      setError("");
      setShowCouponList(false);
      localStorage.removeItem('appliedCoupon');
    };


    const renderCouponSection = () => {
      if (!isCouponApplied) {
        return (
          <div className="space-y-4">
            <button
              onClick={handleCouponButtonClick}
              className="w-full relative overflow-hidden group"
            >
              <div className="bg-gradient-to-r from-[#FF0000] via-[#FF6F00] to-[#FFEB3B] p-4 rounded-lg flex items-center justify-between shadow-md hover:shadow-lg transition-all">
                <div className="text-white font-bold text-lg">
                  {showCouponList ? 'HIDE COUPONS' : 'APPLY COUPON'}
                </div>
                <TagIcon className="h-6 w-6 text-white" />
              </div>
            </button>

            {showCouponList && (
              <div className="mt-2 border rounded-lg shadow-md">
                {isLoading ? (
                  <div className="p-4 text-center text-gray-600">Loading coupons...</div>
                ) : coupons.length > 0 ? (
                  coupons.map((coupon) => (
                    <div key={coupon.couponcode} className="p-3 border-b last:border-b-0 hover:bg-gray-50">
                      <div className="flex justify-between items-center">
                        <div>
                          <div className="font-sms text-gray-800">{coupon.couponcode}</div>
                          <div className="text-sm text-gray-600">Min value: ₹{coupon.min_cart_amt}</div>
                          <div className="text-sm text-green-600">Discount {coupon.discount}%</div>
                        </div>
                        <button
                          onClick={() => handleApplyCoupon(coupon)}
                          className="px-3 py-1 bg-[#FF0000] text-white rounded-full text-sm hover:bg-red-700 transition-colors"
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="p-4 text-center text-gray-600">No active coupons available</div>
                )}
              </div>
            )}

            {error && (
              <div className="p-2 text-center text-red-600 text-sm bg-red-50 rounded-lg">
                {error}
              </div>
            )}
          </div>
        );
      }

      return (
        <div className="bg-green-50 p-4 rounded-lg">
          <div className="flex justify-between items-center">
            <div>
              <div className="font-bold text-green-800">{appliedCoupon.couponcode}</div>
              <div className="text-sm text-green-600">₹{appliedCoupon.discountAmount.toFixed(2)} discount applied</div>
            </div>
            <button onClick={removeCoupon} className="text-red-500 hover:text-red-700">
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>
      );
    };

    const renderTotalSection = () => {
      const originalTotal = calculateGrandTotal();
      const discountedTotal = calculateDiscountedGrandTotal();
      const savings = originalTotal - discountedTotal;

      return (
        <div className="p-4 border-t bg-white space-y-4">
          <div className="space-y-2">


            {appliedCoupon && (
              <div className="flex justify-between text-green-600">
                <span>Discount ({appliedCoupon.discount}%):</span>
                <span>-₹{savings.toFixed(2)}</span>
              </div>
            )}

            <div className="flex justify-between font-bold text-lg text-orange-600">
              <span>Final Total:</span>
              <span>₹{discountedTotal.toFixed(2)}</span>
            </div>
          </div>

          <button
            onClick={handleSubmit}
            className={`w-full py-2 px-4 ${isAddressValid ? 'bg-orange-600 hover:bg-orange-700' : 'bg-gray-400'
              } text-white font-bold rounded-lg transition-colors`}
            disabled={loading || !isAddressValid}
          >
            {loading ? 'Processing...' : 'Pay At Once'}
          </button>

          {!isAddressValid && (
            <p className="text-red-500 text-sm">Please add a valid address to proceed with payment.</p>
          )}
          {error && (
            <p className="text-red-500 text-sm">{error}</p>
          )}
        </div>
      );
    };



    const renderToggleSection = () => {
      if (!isGroupAdmin) return null;

      return (
        <div className="flex items-center mt-2 px-2">
          <span className="ml-4 text-orange-500 text-lg font-semibold tracking-wide font-inter">
            {isCartToggle ? 'Open Cart' : 'Closed Cart'}
          </span>
          <div className="ml-auto">
            <button
              onClick={handleCartToggle}
              className={`relative w-16 h-8 rounded-full transition-colors duration-200 ${isCartToggle ? 'bg-blue-500' : 'bg-gray-300'
                }`}
            >
              <span
                className={`absolute left-1 top-1 w-6 h-6 bg-white rounded-full shadow transform transition-transform duration-200 ${isCartToggle ? 'translate-x-8' : 'translate-x-0'
                  }`}
              ></span>
            </button>
          </div>
        </div>
      );
    };


    const renderMemberCart = (cart, isCurrentUser = false) => {
      const hasOutOfStockItems = cart.cartData.some(item => stockLevels[item.productid]);
   return(
    <div 
    key={cart.memberId} 
    className={`mb-6 p-4 rounded-lg bg-white shadow-md 
      ${hasOutOfStockItems ? 'border-2 border-red-500' : ''}`}
  >        <div
          className={`flex items-center justify-between ${!isCurrentUser && isCartToggle ? 'cursor-pointer' : ''}`}
          onClick={() => !isCurrentUser && isCartToggle && toggleCart(cart.memberId)}
        >
          <div className="flex items-center gap-2">
            <Users className="h-5 w-5 text-orange-600" />
         
            <h3 className={`font-semibold text-lg ${hasOutOfStockItems ? 'text-red-500' : ''}`}>
            {isCurrentUser
              ? 'Your Cart'
              : `${customerData.find(customer => customer.customer_generated_id === cart.memberId)?.customer_name || cart.memberId}'s Cart`}
          </h3>
          </div>
          <div className="flex items-center gap-2">
          <span className={`font-bold ${hasOutOfStockItems ? 'text-red-500' : 'text-orange-600'}`}>
              ₹{cart.totalAmount}
            </span>
            {!isCurrentUser && isCartToggle && (
              <ChevronDown
                className={`h-5 w-5 transition-transform ${expandedCarts[cart.memberId] ? 'rotate-180' : ''}`}
              />
            )}
          </div>
        </div>

        {(isCurrentUser || (isCartToggle && expandedCarts[cart.memberId])) && (
          <div className="space-y-4 mt-4">
            {cart.cartData.map((item) => {
              const isOutOfStock = stockLevels[item.productid];
              return (
                <div
                  key={`${item.productid}-${item.selectedPack}`}
                  className={`flex items-center gap-4 p-3 border rounded-lg bg-gray-50 
                    ${isOutOfStock ? 'border-red-500' : ''}`}
                >
                  <img
                    src="https://cdn4.vectorstock.com/i/1000x1000/31/08/diwali-crackers-background-vector-4593108.jpg"
                    alt={item.ItemName}
                    className="w-16 h-16 object-cover rounded-lg"
                  />

                  <div className="flex-1">

                    <h4 className="font-medium">{item.ItemName}</h4>

                    <p className="text-sm text-gray-600">{item.selectedPack}</p>
                    <p className="text-orange-600">₹{item[item.selectedPack]}</p>

                  </div>


                  <div className="flex flex-col items-end gap-2 ">
                    {isOutOfStock && (
                      <span className="text-xs text-red-500 font-medium px-2 py-1 bg-red-50 rounded">
                        Out of Stock</span>
                    )}
                    <p className="font-semibold mr-6">
                      ₹{(item[item.selectedPack] * item.quantity)}
                    </p>
                    {isCurrentUser && (
                      <div className="flex items-center gap-2 mt-2">
                        <button
                          onClick={() => updateCartQuantity(item.productid, item.selectedPack, item.quantity - 1)}
                          className="p-1 rounded-full bg-gray-200 hover:bg-gray-300"
                          disabled={item.quantity <= 1}
                        >
                          <Minus className="h-4 w-4" />
                        </button>
                        <span className="w-8 text-center">{item.quantity}</span>
                        <button
                          onClick={() => updateCartQuantity(item.productid, item.selectedPack, item.quantity + 1)}
                          className="p-1 rounded-full bg-gray-200 hover:bg-gray-300"
                          disabled={isOutOfStock}

                        >
                          <Plus className="h-4 w-4" />
                        </button>
                        <button
                          onClick={() => removeFromCart(item.productid, item.selectedPack)}
                          className="ml-auto text-red-600 hover:text-red-700"
                        >
                          <Trash2 size={20} />
                        </button>
                      </div>
                    )}
                    {!isCurrentUser && (
                      <p className="text-sm text-gray-600">
                        Qty: {item.quantity}
                      </p>
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </div>
    )};


    const calculateGrandTotal = () => {
      let total = 0;

      // Add total from other member carts
      if (otherMemberCarts && otherMemberCarts.length > 0) {
        total += otherMemberCarts.reduce((sum, cart) => sum + cart.totalAmount, 0);
      }

      // Add current user's cart total
      if (currentUserCart) {
        total += currentUserCart.totalAmount;
      }

      return total;
    }

    const renderAddressSection = () => (
      <div className="mt-4 flex justify-between items-center">
        <div className="text-sm">
          {address && Object.keys(address).length > 0 ? (
            <>
              <p>{address.line1}</p>
              <p>{address.line2}</p>
              <p>{address.pincode}</p>
            </>
          ) : (
            <p className="text-gray-200">
              {isGroupAdmin
                ? "No address set. Please add one for the group."
                : "Waiting for admin to set delivery address."}
            </p>
          )}
        </div>
        {isGroupAdmin && (
          <button
            onClick={handleChangeAddress}
            className="bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-sm"
          >
            {address && Object.keys(address).length > 0 ? 'Add Address' : 'change Address'}
          </button>
        )}
      </div>
    );

    const isAddressValid = address && address.line1 && address.line2 && address.pincode;
    return (
      <div className={`fixed right-0 top-0 h-full w-96 bg-white shadow-2xl transform transition-transform duration-300 ease-in-out ${isCartOpen ? "translate-x-0" : "translate-x-full"} z-50`}>
        <div className="h-full flex flex-col">
          <div className="p-4 border-b bg-orange-600 text-white">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-bold">Shopping Cart</h2>
              <button onClick={() => setIsCartOpen(false)}>
                <X className="h-6 w-6" />
              </button>
            </div>
            {renderAddressSection()}
          </div>
          {/* cart Toggle */}

          {renderToggleSection()}


          <div className="p-4 bg-white border-b">
            {renderCouponSection()}
          </div>

          <div className="flex-1 overflow-y-auto p-4">
            {isLoading ? (
              <div className="text-center py-8">Loading carts...</div>
            ) : error ? (
              <div className="text-center py-8 text-red-600">{error}</div>
            ) : (
              <div className="space-y-6">

                {otherMemberCarts.map(cart => renderMemberCart(cart))}

                {currentUserCart && renderMemberCart(currentUserCart, true)}


              </div>
            )}
          </div>


          {renderTotalSection()}


        </div>
      </div>


    );
  };

  const CartIcon = () => (
    <div className="relative cursor-pointer" onClick={() => setIsCartOpen(true)}>
      <ShoppingCart data-testid="cart" className="h-6 w-6 text-gray-600 hover:text-orange-600" />
      {currentUserCart && currentUserCart.cartData && currentUserCart.cartData.length > 0 && (
        <span data-testid='CartCount' className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
          {currentUserCart.cartData.length}
        </span>
      )}
    </div>
  );

  const handleClickOutside = (e) => {
    if (!e.target.closest('.profile-menu')) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);


  const ProfileDropdown = () => {
    const [showGroupOptions, setShowGroupOptions] = useState(false);

    const handleGroupOrdersClick = () => {
      setShowGroupOptions(!showGroupOptions);
    };

    const handleMouseEnter = () => {
      setShowGroupOptions(true);
    };

    const handleMouseLeave = () => {
      if (!showGroupOptions) {
        setShowGroupOptions(false);
      }
    };

    return (
      <div className="absolute top-12 right-0 bg-white border border-gray-300 shadow-lg rounded-lg p-4 transition-all duration-300">
        <div className="flex flex-col items-start space-y-3">
          <button
            onClick={() => {
              navigate('/mygrouporders');
            }}
            className="text-gray-700 hover:text-blue-600 font-medium py-2 px-4 transition-colors duration-200 rounded-lg w-full text-left whitespace-nowrap"
          >
            My Group Orders
          </button>
          <button
            onClick={() => {
              navigate('/shop');
            }}
            className="text-gray-700 hover:text-blue-600 font-medium py-2 px-4 transition-colors duration-200 rounded-lg w-full text-left whitespace-nowrap"
          >
            Go Back
          </button>

          <button
            onClick={handleLogout}
            className="text-gray-700 hover:text-red-600 font-medium py-2 px-4 transition-colors duration-200 rounded-lg w-full text-left"
          >
            Logout
          </button>
        </div>
      </div>
    );
  };

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen)
  }
  const selectedItems = CategoryData.find(cat => cat.category === selectedCategory)?.items || [];




  const PackButtonSelector = ({ item, availablePacks = [], onToggle }) => {
    const selectedPack = itemToggleStates[item.productid];

    return (
      <div className="flex items-center gap-3">
        <span className="text-sm font-large font-bold text-orange-500">Pack</span>
        <div className="flex gap-2">
          {availablePacks.map((pack) => (
            <button
              key={pack}
              onClick={() => onToggle(item.productid, pack)}
              className={`
min-w-1 px-2 py-1.5 

text-sm font-medium
transition-all duration-200 
${selectedPack === pack
                  ? 'bg-orange-500 text-white'
                  : 'bg-white text-gray-600 hover:bg-orange-50 hover:text-orange-600'
                }
`}
            >
              {pack.replace('PackOf', '')}
            </button>

          ))}
        </div>
      </div>
    );
  };
  const GridItem = ({ item }) => {
    const availablePacks = [];
    if (item.PackOf1) availablePacks.push('PackOf1');
    if (item.PackOf2) availablePacks.push('PackOf2');
    if (item.PackOf5) availablePacks.push('PackOf5');
    if (item.PackOf10) availablePacks.push('PackOf10');

    const selectedPack = itemToggleStates[item.productid] || availablePacks[0];
    const selectedPrice = selectedPack ? item[selectedPack] : null;
    const quantity = productQuantities[item.productid] || 1;
    const available = Number(stockLevelsforproduct[item.productid]) || 0;

    const isOutOfStockforproduct = available === 0;

    return (
      <div
        className={`bg-white rounded-lg shadow-md overflow-hidden transition-shadow hover:shadow-xl flex flex-col h-full 
      ${isOutOfStockforproduct ? 'opacity-50 pointer-events-none' : ''}`}
      >
        <div className="relative">
          <img
            src="https://cdn4.vectorstock.com/i/1000x1000/31/08/diwali-crackers-background-vector-4593108.jpg"
            alt={item.ItemName}
            className="w-full h-48 object-cover"
          />

          {isOutOfStockforproduct && (
            <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center z-10">
              <span className="text-white font-bold text-xl">Out of Stock</span>
            </div>
          )}
        </div>


        <div className="p-4 flex-grow flex flex-col justify-between">
          <div>
            <h3 className="text-lg font-semibold mb-2 line-clamp-2">{item.ItemName}</h3>
            <div className="space-y-2 mb-4">
              <p className="text-gray-600">Brand: {item.Brand}</p>
              <div className="flex items-center justify-between mb-3">
                {selectedPrice && (
                  <p className="text-orange-600 font-bold">₹{selectedPrice}</p>
                )}
                <div className="flex items-center gap-2">
                  <button
                    data-testid="gridMinus"
                    onClick={() => handleQuantityChange(item.productid, -1)}
                    className="p-1 rounded-full bg-gray-200 hover:bg-gray-300"
                  >
                    <Minus className="h-3 w-3" />
                  </button>
                  <span className="w-4 text-center font-medium">{quantity}</span>
                  <button
                    data-testid="gridPlus"
                    onClick={() => handleQuantityChange(item.productid, 1)}
                    className="p-1 rounded-full bg-gray-200 hover:bg-gray-300"
                  >
                    <Plus className="h-3 w-3" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col space-y-4 mt-auto">
            <div className="bg-gray-50 p-3 rounded-lg">
              <PackButtonSelector
                item={item}
                availablePacks={availablePacks}
                onToggle={handleToggleChange}
              />
            </div>

            <div>
              <button
                className="w-full bg-orange-600 text-white px-4 py-2 rounded-lg hover:bg-orange-700 transition-colors"
                onClick={() => handleAddToCart(item, selectedPack, address)}
                data-testid='cartbutton'
              >
                Add to Cart
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };



  const filteredCategories = CategoryData.filter((category) =>
    category.category.toLowerCase().includes(searchTerm.toLowerCase()));
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="w-full bg-gradient-to-r from-[#FF0000] via-[#FF6F00] to-[#FFEB3B] shadow-md fixed top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Left Section */}
            <button
              className="md:hidden mr-4 text-gray-600 hover:text-orange-600"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
            <div className="flex-shrink-0 flex items-center">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBF1UvCpn4kVzNpTg9TKuANf-XXeQljIv_5B_vs6l8LBFhzCsmPWpJkYYi004pM3mKCb4&usqp=CAU"
                alt="Logo"
                className="h-10 w-10 mr-2 cursor-pointer object-contain rounded-full border-2 border-orange-500"
              />
              <h1 className="text-xl font-bold">Mera Crackers</h1>
            </div>

            {/* Middle Section - Search */}
            <div className="flex-1 max-w-xl mx-auto px-4">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full px-4 py-2 border rounded-full focus:outline-none focus:ring-2 focus:ring-orange-500"
                />
                <Search className="absolute right-3 top-2.5 h-5 w-5 text-gray-400" />
              </div>
              {searchTerm && (
                <div className="absolute bg-white border border-gray-300 rounded shadow-md max-h-64 overflow-y-auto w-full z-10">
                  {filteredCategories.map((category) => (
                    <div
                      key={category.category}
                      className="py-2 px-4 hover:bg-orange-100 cursor-pointer"
                      onClick={() => handleSelectCategory(category.category)}
                    >
                      {category.category}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Right Section */}
            <div className="flex items-center space-x-6 relative">
              <div onClick={toggleDropdown} className="relative cursor-pointer">
                <User data-testid='user' className="h-6 w-6 text-gray-600 hover:text-orange-600" />
                {isDropdownOpen && <ProfileDropdown />}
              </div>
              <CartIcon />
            </div>
          </div>
          <div className="md:hidden py-4">
            <div className="relative">
            </div>
          </div>
        </div>
      </header>


      <div className={`fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300 md:hidden ${isMobileMenuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        onClick={() => setIsMobileMenuOpen(false)}
      />

      {/* Main Content */}
      <div className="pt-24 md:pt-16">
        <div className="flex">
          <div className={`fixed md:sticky md:top-16 h-full md:h-[calc(100vh-4rem)] overflow-y-auto
              w-64 md:w-40 bg-white shadow-lg transition-transform duration-300 ease-in-out z-40
              ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'} 
              md:translate-x-0`}>
            <div className="p-4 sticky top-0 bg-white z-10">
              <div className="flex justify-center">
                <h2 className="text-xl font-bold mb-4 text-orange-600">Collections</h2>
              </div>
              {isCatLoading ? (
                <div className="flex justify-center items-center h-64">
                  <Oval
                    height={50}
                    width={50}
                    color="#ff6600"
                    visible={true}
                    secondaryColor="#f3f3f3"
                    strokeWidth={2}
                    strokeWidthSecondary={2}
                  />
                </div>
              ) : (
                <div className="grid grid-cols-1 gap-4">
                  {CategoryData.map((category) => (
                    <div
                      key={category.category}
                      className={`flex flex-col items-center cursor-pointer transition-all duration-300
                    ${selectedCategory === category.category
                          ? 'transform scale-105'
                          : 'hover:transform hover:scale-105'}`}
                      onClick={() => handleSelectCategory(category.category)}
                    >
                      <div className={`w-16 h-16 rounded-full overflow-hidden mb-2 border-2
                    ${selectedCategory === category.category
                          ? 'border-orange-500 shadow-lg'
                          : 'border-gray-200'}`}>
                        <img
                          src={category.image}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <span className={`text-center text-sm font-medium
                    ${selectedCategory === category.category
                          ? 'text-orange-600'
                          : 'text-gray-600'}`}>
                        {category.category}
                      </span>
                    </div>
                  ))}
                </div>)}
            </div>
          </div>

          <div className="flex-1 p-4">
            <div className="relative h-96 overflow-hidden rounded-lg shadow-lg bg-white">
              {carouselImages.map((image, index) => (
                <div
                  key={image.id}
                  className={`absolute w-full h-full transition-opacity duration-1000 
                  ${index === currentSlide ? 'opacity-100' : 'opacity-0'}`}
                >
                  <img
                    src={image.image}
                    alt={`Slide ${image.id}`}
                    className="w-full h-full object-cover rounded-lg"
                  />
                </div>
              ))}
            </div>

            <div className="container mx-auto px-4 py-8">
              <div ref={exclusiveRangeRef} className="container mx-auto px-4">
                {isCatLoading ? (
                  <div className="flex justify-center items-center h-64">
                    <Oval
                      height={50}
                      width={50}
                      color="#ff6600"
                      visible={true}
                      secondaryColor="#f3f3f3"
                      strokeWidth={2}
                      strokeWidthSecondary={2}
                    />
                  </div>
                ) : selectedItems.length > 0 ? (
                  <div className="mt-8">
                    <h2 className="text-2xl font-bold mb-6 text-gray-800 text-center">Our Exclusive Range</h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                      {selectedItems.map((item) => (
                        <GridItem key={item.productid} item={item} />
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="text-center text-gray-500 mt-10">No items found.</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <CartModal
        isOpen={isCartOpen}
        onClose={() => setIsCartOpen(false)}
        onChangeAddress={handleChangeAddress}
      />
      <ToastContainer />
    </div>
  );
};

export default Groups;


